import { createSelector } from 'reselect';

const selectGlobal = (state) => state.get('appReducer');

const selectUser = () => createSelector(
  selectGlobal,
  (appReducer) => appReducer.get('user').toJS()
);

const selectToken = () => createSelector(
  selectGlobal,
  (appReducer) => appReducer.get('token')
);


const selectCurrentOrganization = () => createSelector(
  selectGlobal,
  (appReducer) => appReducer.get('currentOrganization').toJS()
);


const selectLoaded = () => createSelector(
  selectGlobal,
  (appReducer) => appReducer.get('isLoaded')
);

const selectOrganizations = () => createSelector(
  selectGlobal,
  (appReducer) => appReducer.get('organizations').toJS()
);

const selectOrganizationsFetched = () => createSelector(
  selectGlobal,
  (appReducer) => appReducer.get('isOrganizationsFetched')
);

const selectOrganizationCount = () => createSelector(
  selectGlobal,
  (appReducer) => appReducer.get('organizationCount')
);

const selectUserFetched = () => createSelector(
  selectGlobal,
  (appReducer) => appReducer.get('isUserFetched')
);

const selectSmallMainNav = () => createSelector(
  selectGlobal,
  (appReducer) => appReducer.get('isSmallMainNav')
);



// selectLocationState expects a plain JS object for the routing state
const selectLocationState = () => {
  let prevRoutingState;
  let prevRoutingStateJS;

  return (state) => {
    const routingState = state.get('route'); // or state.route
    if (!routingState.equals(prevRoutingState)) {
      prevRoutingState = routingState;
      prevRoutingStateJS = routingState.toJS();
    }

    return prevRoutingStateJS;
  };
};

export {
  selectGlobal,
  selectLocationState,
  selectUser,
  selectToken,
  selectOrganizations,
  selectOrganizationsFetched,
  selectCurrentOrganization,
  selectUserFetched,
  selectLoaded,
  selectSmallMainNav,
  selectOrganizationCount
};
